import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class TicketForFmtRequest extends ApiGetRequest
{
    public constructor(ticketNumber: number = null, ticketLetter: string = null, webapiBasepath: string)
    {
        const parameters = new ApiParameters();

        if (ticketNumber != null && ticketLetter != null)
        {
            parameters
                .addQueryParameter('ticketnumber', ticketNumber)
                .addQueryParameter('ticketletter', ticketLetter);
        }

        super(  'ticketforfmt',
                 parameters,
                 null,
                 webapiBasepath
        );
    }
}
